import groq from 'groq'
import pressField from '../fields/press'

export default groq`
  *[_type == "press"]{
    ...${pressField}
  }
`
